/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RightCart from "./RightCard";
import ThePoints from "./Thepoints";
import Refundable from "./Refundable";
import SelectCard from "./SelectCard";
import { useDispatch, useSelector } from "react-redux";
import defaultImage from "../../../src/Assets/fallbackimg_giftcard.png";
import Loader from "../Loader/Loader";
import axiosInstance from "../../Common/Axios/axiosInstance";
import { toast } from "react-toastify";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { onGetClientCapping } from "../../Store/Slices/clientCappingSlice";
import {
  ApiRespCode,
  checkTransactionLimit,
  ClientInfo,
  Dispatch,
  EarnPoint,
  formatPrice,
  roundCurrency,
  GenerateToken,
  getImageUrl,
  GetMemberData,
  GetProdBudSumData,
  handleLimit,
  LoginReducerData,
  LoginV3Data,
  OrderData,
  RedeemPoint,
  SendMail,
  SendSms,
  showMaxMessg,
  SupplierCapping,
  trackEvent,
  TransactionLimit,
  useGaTrackingConfig,
  useClientConfigFlag,
  usePoints,
  V3Data,
  VendorData,
  CardBasedRedemptionList,
  getCardMasterData
} from "../Utility/Utility";
import { onPostEarnPointReset } from "../../Store/Slices/earnPointSlice";
import { onGenerateTokenSubmitReset } from "../../Store/Slices/generateTokenSlice";
import { onPostVendorOrderReset } from "../../Store/Slices/vendorOrderSlice";
import { onPendingOrderReset, onPostOrderReset, onUpdateOrderReset } from "../../Store/Slices/orderSlice";
import { decryptAES } from "../../Common/Axios/encrypt";
import { decryptURLParam } from "../../Common/Axios/encrypt";
import API from "../../Common/Endpoint/serviceConstrants";
import { onGetMail } from "../../Store/Slices/sendMailSlice";
import { useRef } from "react";
import { setProduct } from "../../Store/Slices/productDataSlice";
import { getProductList } from "../../Store/Slices/productSlice";
import PurchaseLimitAlertTile from "../PurchaseLimitAlertTile/PurchaseLimitAlertTile";
import { onGetCustomerProduct } from "../../Store/Slices/customerProductSummarySlice";
import RewardWidget from "../RewardWidget/RewardWidget";
import warning from "../../Assets/warning2.png";
import { use } from "react";
import ProductAttributes from "../ProductAttributes/ProductAttributes";
import ReedemType from "./RedeemType";
import PurchaseLimitPill from "../Giftcards/PurchaseLimitPill";
import CheckoutPage from "./CheckoutPage";
import { CheckoutProvider } from "./context/CheckoutContext";
import { map } from "jquery";
import { onSavePoints } from "../../Store/Slices/cardDataSlice";
import { callActiveCardPostApi } from "../../Context/activeCardApi";
import RewardRedemption from "./RewardRedemption";
import { getRewardCapabilities } from "./utils/rewardCapabilities";
import { calculateCartPricing } from "./hooks/useCartPricing";

const readHostedPayUReturnData = () => {
  try {
    const savedCancelUrl = sessionStorage.getItem("cancelUrl");
    const savedCheckoutData = sessionStorage.getItem("PayUHostedCheckoutData");
    const productInfo = sessionStorage.getItem("OrderPayloadSession");
    if (!savedCancelUrl || !savedCheckoutData) return null;

    const cancelUrl = new URL(JSON.parse(savedCancelUrl), window.location.origin);
    const currentUrl = new URL(window.location.href);
    const checkoutData = JSON.parse(savedCheckoutData);
    const savedProductId = productInfo ? JSON.parse(productInfo)?.productId : null;
    const returnedProductId = decryptAES(currentUrl.searchParams.get("productId"));
    const isCancelReturn =
      currentUrl.searchParams.get("paymentCancelled") === "true" ||
      window.history.state?.payuHostedReturnId === checkoutData?.savedAt;
    const matchesReturnUrl =
      cancelUrl.origin === currentUrl.origin &&
      cancelUrl.pathname === currentUrl.pathname &&
      isCancelReturn &&
      (!savedProductId || !returnedProductId || savedProductId === returnedProductId);
    const age = Date.now() - Number(checkoutData?.savedAt);
    const isRecent = age >= 0 && age < 30 * 60 * 1000;

    if (!matchesReturnUrl || !isRecent || !Array.isArray(checkoutData?.sourceData)) {
      return null;
    }

    return {
      sourceData: checkoutData.sourceData,
      isPaymentCancelled: true,
      savedAt: checkoutData.savedAt,
      productId: savedProductId,
    };
  } catch (error) {
    return null;
  }
};

const Voucher = (productReducer) => {
  const navigate = useNavigate();
  const location = useLocation();
  const minDenomination = parseInt(
    productReducer?.productReducer?.clientProductDenomination?.map((item) => item.denomination).sort((a, b) => a - b)[0]
  );
  const v3Data = V3Data();
  const supplierCapping = SupplierCapping();
  const loginReducerData = LoginReducerData();
  const memberData = GetMemberData();
  const redeemPoint = RedeemPoint();
  const clientInfo = ClientInfo();
  const vendorData = VendorData();
  const generateToken = GenerateToken();
  const sendSms = SendSms();
  const translation = getTranslationData();
  const transactionLimit = TransactionLimit();
  // const productId = productReducer?.productReducerDisocount?.id;
  // const clientProductMapping = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer?.data?.[0]?.clientProductMapping
  // );

  const [points, setPoints] = useState(0);
  const [cash, setCash] = useState(0);
  const [orderJourneyStarted, setOrderJourneyStarted] = useState(false);
  const productData = productReducer?.productReducer;
  const [loading, setLoading] = useState(false);
  const [burnPoints, setBurnPoints] = useState(0);
  const [earnPoints, setEarnPoints] = useState(0);
  const [razorPayKey, setRazorPayKey] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const productDetails = productReducer?.productReducer;
  const [finalPayableAmount, setFinalPayableAmount] = useState(0);
  const [stockOutDenominations, setStockOutDenominations] = useState();
  const [outOfStockLabel, setOutOfStockLabel] = useState([]);
  const [filterStockOutDenominations, setFilterStockOutDenominations] = useState([]);
  const [isBuyNowAmountUpdating, setIsBuyNowAmountUpdating] = useState(false);
  const [hostedReturnData] = useState(readHostedPayUReturnData);

  useLayoutEffect(() => {
    if (!hostedReturnData) return;

    const currentUrl = new URL(window.location.href);
    const historyState = window.history.state;
    if (historyState?.payuHostedReturnId !== hostedReturnData.savedAt) {
      sessionStorage.removeItem("PayUHostedCancelUpdateSubmitted");
    }
    if (hostedReturnData.productId && !currentUrl.searchParams.get("productId")) {
      currentUrl.searchParams.set("productId", hostedReturnData.productId);
    }
    currentUrl.searchParams.delete("paymentCancelled");
    window.history.replaceState(
      { ...historyState, payuHostedReturnId: hostedReturnData.savedAt },
      "",
      currentUrl.toString(),
    );
  }, [hostedReturnData]);

  const getcardBasedRedemptionList = CardBasedRedemptionList();
  const loginV3Data = LoginV3Data();
  const gaTrackingConfig = useGaTrackingConfig();

  // const [selectedCard, setSelectedCard] = useState({});
  const clientConfigurations = clientInfo?.clientData?.clientConfigurations;
  const clientConfigReducer = useSelector(
    (state) => state.clientConfigurationReducer?.clientConfigurationData?.[0]
  );
  const discountShowLabelConfig =
    clientConfigReducer?.clientConfig?.find(
      (item) => String(item?.configKey ?? "").trim().toLowerCase() === "isdiscountlabeldisplay"
    )?.configValue ?? clientConfigReducer?.isDiscountLabelDisplay;
  const isDiscountShowLabelConfig =
    discountShowLabelConfig === true ||
    discountShowLabelConfig === 1 ||
    ["1", "true", "active"].includes(String(discountShowLabelConfig ?? "").trim().toLowerCase());
  const isProductAttributeGridEnabled = useClientConfigFlag(
    "isProductAttributeGridDisplay"
  );
  const cardListData = useSelector((state) => state.clientConfigDataReducer);
  const journeyType = clientInfo?.clientData?.journeyType
  const isWalletJourney =
    journeyType === true ||
    journeyType === 1 ||
    String(journeyType).trim().toLowerCase() === "true" ||
    String(journeyType).trim() === "1";
  const isCardJourney = !isWalletJourney;
  const [cardBasedRedemtionList, setCardBasedRedemtionList] = useState(null);
  const [selectedCardBasedRedemtion, setselectedCardBasedRedemtion] = useState(null);
  const [cardBalances, setCardBalances] = useState({});
  const cardMasterData = useSelector((state) => state.cardMasterReducer.cardMasterData) || [];
  const MatchedCardMasterData = getCardMasterData(selectedCardBasedRedemtion?.CardTypeName, cardMasterData);
  const shouldApplyCardToggle = isCardJourney;
  const [totalAmount, setTotalAmount] = useState();
  const hasMatchedCardMasterData = !!MatchedCardMasterData;
  const isBurn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isburn"
  )?.configValue;
  const isEarn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearn"
  )?.configValue;
  const rewardCapabilities = getRewardCapabilities({
    clientEarnActive: isEarn ?? true,
    clientBurnActive: isBurn ?? true,
    cardMasterEarnActive: shouldApplyCardToggle
      ? !hasMatchedCardMasterData || MatchedCardMasterData?.earnEnabled !== false
      : true,
    cardMasterBurnActive: shouldApplyCardToggle
      ? !hasMatchedCardMasterData || MatchedCardMasterData?.burnEnabled !== false
      : true,
    product: productData,
  });
  const {
    clientEarnActive: isClientEarnEnabled,
    clientBurnActive: isClientBurnEnabled,
    cardMasterEarnActive: isEarnEnabledForSelectedCard,
    cardMasterBurnActive: isBurnEnabledForSelectedCard,
    productSupportsEarn,
    productSupportsBurn,
    effectiveEarn,
    effectiveBurn,
  } = rewardCapabilities;

  const getSelectedRewardCardData = () => {
    const cards = cardListData?.clientConfigData?.cards || [];
    if (cards.length === 0) return null;

    const selectedRewardWidgetCardId = localStorage.getItem("RewardWidget");
    return (
      cards.find(
        (card) =>
          String(card?.cardId) === String(selectedRewardWidgetCardId)
      ) || cards.find((card) => card?.isSelected) || null
    );
  };

  const calculateRewardPoints = (amount, cardData) => {
    const payableAmount = Number(amount) || 0;
    const perRs = Number(cardData?.perRs) || 0;
    const standardPoints = Number(cardData?.standardPoints) || 0;
    const bonusPoints = Number(cardData?.bonusPoints) || 0;

    if (!cardData || payableAmount <= 0 || perRs <= 0 || standardPoints <= 0) {
      return 0;
    }

    return Math.round(
      (payableAmount / perRs) *
      standardPoints *
      (bonusPoints / standardPoints + 1)
    );
  };

  // Capture the previous page URL on mount (before current route renders)
  //const prevUrl = useRef(document.referrer || window.location.href);
  useEffect(() => {
    if (!getcardBasedRedemptionList || !isCardJourney) return;
    const freshCards = getcardBasedRedemptionList[0]?.valueDetails ?? [];
    setCardBasedRedemtionList(freshCards);
    const savedCardId = isCardJourney
      ? localStorage.getItem("selectedCardId")
      : sessionStorage.getItem("selectedCardId");
    const defaultCard =
      (savedCardId && freshCards.find(
        (card) => String(card?.identifier) === String(savedCardId)
      ))
      ?? freshCards.find((c) => c?.identifier === loginV3Data?.subIdentifier)
      ?? freshCards[0]
      ?? null;
    setselectedCardBasedRedemtion(defaultCard);
    const activeCards = freshCards.filter((c) => c?.status !== "0");
    activeCards.forEach((card) => {
      const identifier = card?.identifier;
      if (!identifier) return;
      setCardBalances((prev) => ({ ...prev, [identifier]: { loading: true, failed: false, points: null } }));
      (async () => {
        try {
          const data = await callActiveCardPostApi({
            identifier: loginV3Data?.memberIdentifier,
            subIdentifier: identifier,
            identifierType: card?.identifiertype ? JSON.parse(card?.identifiertype) : 1002,
            isAccountSwitch: false,
            userSessionToken: sessionStorage.getItem("loginSessionToken"),
          });
          if (data?.errorCode === "200") {
            const pointBalance = Math.floor(data?.response?.response?.memberBalance?.pointBalance ?? 0);
            setCardBalances((prev) => ({ ...prev, [identifier]: { loading: false, failed: false, points: pointBalance } }));
            if (identifier === defaultCard?.identifier) {
              dispatch(onSavePoints({
                pointBalance: parseInt(pointBalance),
                identifierType: card?.identifiertype,
                subIdentifier: identifier,
              }));
            }
          } else {
            setCardBalances((prev) => ({ ...prev, [identifier]: { loading: false, failed: true, points: null } }));
          }
        } catch {
          setCardBalances((prev) => ({ ...prev, [identifier]: { loading: false, failed: true, points: null } }));
        }
      })();
    });
  }, [getcardBasedRedemptionList, isCardJourney]);
  const cards = useMemo(() => (
    cardBasedRedemtionList?.filter((card) => {
      const matchedCard = cardMasterData?.find(
        (item) => item.cardName === card.CardTypeName
      );

      const visibility = String(matchedCard?.isCustomerVisible ?? "true")
        .trim()
        .toLowerCase();
      const isCustomerVisible = isCardJourney
        ? !["false", "0", "no"].includes(visibility)
        : (!matchedCard || matchedCard.isCustomerVisible);

      return card.status !== "0" && isCustomerVisible;
    }) ?? []
  ), [cardBasedRedemtionList, cardMasterData, isCardJourney]);
  const [selectedCardId, setSelectedCardId] = useState(() => (
    isCardJourney ? localStorage.getItem("selectedCardId") : null
  ));

  useEffect(() => {
    if (!isCardJourney) {
      if (cards.length > 0 && !selectedCardId) {
        setSelectedCardId(
          selectedCardBasedRedemtion?.identifier ?? cards[0]?.identifier ?? null
        );
      }
      return;
    }

    // The initial empty array is a loading state. Keep the persisted card ID
    // until the card API has returned and visibility filtering can run.
    if (!cardBasedRedemtionList) return;

    if (cards.length === 0) {
      setSelectedCardId(null);
      setselectedCardBasedRedemtion(null);
      sessionStorage.removeItem("selectedCardId");
      return;
    }

    const visibleSelectedCard =
      cards.find(
        (card) => String(card?.identifier) === String(selectedCardId)
      )
      ?? cards.find(
        (card) => String(card?.identifier) === String(selectedCardBasedRedemtion?.identifier)
      );
    const nextCard = visibleSelectedCard ?? cards[0];

    if (selectedCardId !== nextCard.identifier) {
      setSelectedCardId(nextCard.identifier);
    }
    if (selectedCardBasedRedemtion?.identifier !== nextCard.identifier) {
      setselectedCardBasedRedemtion(nextCard);
    }
    const nextIdentifier = String(nextCard.identifier);
    if (sessionStorage.getItem("selectedCardId") !== nextIdentifier) {
      sessionStorage.setItem("selectedCardId", nextIdentifier);
    }
    if (localStorage.getItem("selectedCardId") !== nextIdentifier) {
      localStorage.setItem("selectedCardId", nextIdentifier);
    }
  }, [cards, selectedCardId, selectedCardBasedRedemtion, isCardJourney, cardBasedRedemtionList]);

  const previousSelectedCardIdRef = useRef(null);
  useEffect(() => {
    if (!selectedCardId) return;

    const previousCardId = previousSelectedCardIdRef.current;
    const hasCardChanged =
      previousCardId &&
      previousCardId !== selectedCardId;
    if (hasCardChanged) {
      const resetPayableAmount = Number(totalAmount || totalPayableAmount || 0);

      setPoints(0);
      setBurnPoints(0);
      setCash(Number(resetPayableAmount.toFixed(2)));
      setTotalPayableAmount(resetPayableAmount);
    }

    previousSelectedCardIdRef.current = selectedCardId;
  }, [selectedCardId, totalAmount, totalPayableAmount]);

  const supplierCappingList = useSelector(
    (state) => state?.clientCappingSliceReducer?.clientCappingData
  );
  const [quantities, setQuantities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const checkoutSourceData =
    hostedReturnData?.sourceData ||
    (productReducer?.arrayData?.arrayData?.length &&
      productReducer.arrayData.arrayData) ||
    (productReducer?.modalProductData?.length &&
      productReducer.modalProductData);
  const clientProductDenominations =
    productReducer?.productReducer?.clientProductDenomination;
  const updatedData = useMemo(() => {
    if (!checkoutSourceData || !clientProductDenominations) return [];

    const stockMap = new Map(
      clientProductDenominations.map((item) => [
        item.denomination,
        item.stockOut,
      ])
    );
    const availableSourceData = checkoutSourceData.filter(
      (item) => stockMap.get(item.denomination) !== true
    );

    return availableSourceData
      .map((value) => {
        const originalIndex = checkoutSourceData.findIndex(
          (item) => item.denomination === value.denomination
        );
        const quantity = quantities[originalIndex] || 0;
        const unitPayable = value.you_pay == null
          ? Number(value.denomination) *
            (1 - Number(productReducer?.productReducer?.customerDiscount || 0) / 100)
          : Number(value.you_pay);
        return {
          denomination: value.denomination,
          you_pay: unitPayable,
          quantity,
          discountAmount:
            value.denomination * quantity -
            (value.denomination *
              quantity *
              (productReducer?.productReducer?.customerDiscount || 0)) /
            100,
          total: (unitPayable * quantity).toFixed(2),
        };
      })
      .filter((item) => item.quantity > 0);
  }, [
    quantities,
    checkoutSourceData,
    clientProductDenominations,
    productReducer?.productReducer?.customerDiscount,
  ]);
  const { convenienceFeeAmount: convenienceFee, gstAmount: gst } = useMemo(
    () => calculateCartPricing(updatedData, productReducer?.productReducer),
    [updatedData, productReducer?.productReducer],
  );


  const prodSumData = GetProdBudSumData();


  const dispatch = Dispatch();
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    dispatch(onPostEarnPointReset());
    dispatch(onGenerateTokenSubmitReset());
    dispatch(onPostVendorOrderReset());
    dispatch(onPendingOrderReset());
    dispatch(onPostOrderReset());
    dispatch(onUpdateOrderReset());
    setLoading(false);
  }, []);
  useEffect(() => {
    if (productReducer?.productReducer?.clientProductDenomination) {
      const clientProductDeno = productReducer?.productReducer?.clientProductDenomination;
      const productDeno = productReducer?.arrayData?.arrayData || productReducer?.modalProductData;
      if (productDeno) {
        const filterDeno = productDeno?.map(deno => {
          const match = clientProductDeno?.find(
            item => item?.denomination === deno.denomination
          );
          return match?.stockOut === true;
        });
        setOutOfStockLabel(filterDeno || []);
        const outOfStockDenominations = productDeno?.filter((deno, idx) => filterDeno?.[idx] === true);
        setFilterStockOutDenominations(outOfStockDenominations || []);
        setStockOutDenominations(filterDeno?.every((item) => item === true) || false);
      }
    }
  }, [productReducer?.productReducer?.clientProductDenomination, productReducer?.arrayData?.arrayData, productReducer?.modalProductData])
  useEffect(() => {
    getClientInfo();
    dispatch(onGetMail());
    trackEvent("page_browse", {
      page_title: productDetails?.name,
      page_url: window.location.href,
    });
  }, []);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedProductId = urlParams.get("productId");

    // Conditionally decrypt the productId parameter based on environment setting
    const productId = encryptedProductId
      ? process.env.REACT_APP_IS_E_E === "false"
        ? encryptedProductId
        : decryptURLParam(encryptedProductId)
      : productReducer?.productReducer?.id;

    if (!productId) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    if (
      supplierCappingList?.length === 0 ||
      supplierCappingList === undefined
    ) {
      dispatch(onGetClientCapping(parseInt(loginReducerData?.clientId)));
    }

    const payload = {
      productId: productId,
      pageNumber: 1,
      pageSize: 10,
    };
    dispatch(getProductList(payload))
      .then((res) => {
        if (res?.payload?.response?.products) {
          let product = res?.payload.response.products.find(
            (prod) => prod.id === parseInt(productId)
          );
          dispatch(setProduct(product));
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  // value.quantity
  useEffect(() => {
    setQuantities(
      (checkoutSourceData || []).map((value) => Number(value?.quantity) || 0),
    );
  }, [checkoutSourceData]);

  const updateQuantity = (index, change, value) => {
    const current = quantities[index];
    const next = current + change;
    const newQuantities = [...quantities];
    newQuantities[index] = Math.max(0, next);
    const totalQan = newQuantities.reduce((sum, value) => sum + value, 0);
    const sourceData = checkoutSourceData || [];

    const discountPercent =
      Number(productReducer?.productReducerDisocount?.customerDiscount) || 0;
    const projectedTotalDenominationAmount = sourceData.reduce(
      (sum, item, idx) =>
        sum + Number(item?.denomination || 0) * Number(newQuantities[idx] || 0),
      0
    );
    const projectedTotalAfterDiscountAmount =
      projectedTotalDenominationAmount -
      (projectedTotalDenominationAmount * discountPercent) / 100;
    const productMapping = productReducer?.productReducer || {};
    const convenienceFeePercent = Number(productMapping?.convenienceFee) || 0;
    const gstPercent = Number(productMapping?.gst) || 0;
    const projectedConvenienceFeeAmount =
      (projectedTotalAfterDiscountAmount * convenienceFeePercent) / 100;
    const projectedGstAmount =
      (projectedConvenienceFeeAmount * gstPercent) / 100;
    const projectedPayableAmount =
      projectedTotalAfterDiscountAmount +
      projectedConvenienceFeeAmount +
      projectedGstAmount;

    if (change > 0) {
      const { isTransactionLimitExceeded: isProjectedTransactionLimitExceeded } =
        checkTransactionLimit({
          transactionAmountType: transactionLimit?.transactionAmountType,
          totalAmountCapping: transactionLimit?.totalAmountCapping,
          totalDenominationAmount: projectedTotalDenominationAmount,
          totalDenominationAfterDiscountAmount: projectedTotalAfterDiscountAmount,
          payableAmount: projectedPayableAmount,
        });

      if (isProjectedTransactionLimitExceeded) {
        toast.error(translation?.transaction_limit_exceed);
        setIsBuyNowAmountUpdating(false);
        return;
      }
    }

    if (supplierCapping > 0 && next === supplierCapping) {
      showMaxMessg(translation.max_capping_allowed, supplierCapping, 1, value);
    }

    const selectedItem = sourceData[index] || {};
    const eventQuantity = Math.abs(change);
    const denomination = Number(selectedItem?.denomination) || 0;
    const youPay = Number(selectedItem?.you_pay) || 0;
    const totalDiscount = ((denomination * discountPercent) / 100) * eventQuantity;
    const eventItems = [
      {
        index: parseInt(sessionStorage.getItem("ga4_seletedProductIndex")) || null,
        item_id: productReducer?.productReducer?.sku,
        item_brand: productReducer?.productReducer?.name,
        item_name: productReducer?.productReducer?.name,
        affiliation: gaTrackingConfig.trackingContext.affiliation,
        item_category: "Giftcards",
        item_category2: productReducer?.productReducer?.clientCategoryName || "",
        item_image: getImageUrl(productReducer?.productReducer?.small) || defaultImage,
        price: youPay,
        discount: (denomination * discountPercent) / 100 * next,
        gift_card_points: denomination,
        quantity: eventQuantity,
        item_list_name: sessionStorage.getItem("ga4_item_list_name") || "",
        item_list_id: sessionStorage.getItem("ga4_item_list_name") || "",
        item_url: window.location.href.includes("/card?")
          ? window.location.href.replace("/card?", "/giftcard?")
          : window.location.href,
        //  item_url: prevUrl.current,
      },
    ];

    const basePayable = youPay * eventQuantity;

    const convenienceFeeAmount = (basePayable * convenienceFeePercent) / 100;
    const gstAmount = (convenienceFeeAmount * gstPercent) / 100;
    const finalValue = basePayable + convenienceFeeAmount + gstAmount;

    const selectedCard = localStorage.getItem("RewardWidget");
    const cardData = getSelectedRewardCardData();
    const rewardPoints = calculateRewardPoints(projectedPayableAmount, cardData);

    trackEvent(change > 0 ? "add_to_cart" : "remove_from_cart", {
      page_type: "checkout_page",
      client_code: gaTrackingConfig.trackingContext.client_code,
      platform_code: gaTrackingConfig.trackingContext.platform_code,
      item_url: window.location.href.includes("/card?")
        ? window.location.href.replace("/card?", "/giftcard?")
        : window.location.href,
      card_name: selectedCard ? selectedCard : "NA",
      reward_points: rewardPoints,


      total_gift_card_points: denomination * eventQuantity,
      ecommerce: {
        value: finalValue,
        discount: (projectedTotalDenominationAmount - projectedTotalAfterDiscountAmount),
        currency: "INR",
        items: eventItems,
      }
    });

    const updatedAppData = (checkoutSourceData || []).map((item, index) => ({
      ...item,
      quantity: newQuantities[index],
    }));

    if (change !== 0) {
      setIsBuyNowAmountUpdating(true);
    }
    const routerState = location.state;
    const routerStateHasOnlyArrayData =
      routerState &&
      Object.keys(routerState).length === 1 &&
      Array.isArray(routerState.arrayData);
    if (routerStateHasOnlyArrayData) {
      window.history.replaceState(
        { ...window.history.state, usr: { arrayData: updatedAppData } },
        ""
      );
    } else {
      navigate(location.pathname + location.search, {
        state: {
          arrayData: updatedAppData,
        },
        replace: true,
      });
    }
    setQuantities(newQuantities);
  };

  useLayoutEffect(() => {
    let basePayableAmount = 0;

    updatedData?.forEach((item) => {
      basePayableAmount += item.you_pay * item.quantity;
    });

    const finalAmount = roundCurrency(
      basePayableAmount + (convenienceFee || 0) + (gst || 0)
    );
    setTotalAmount(finalAmount);
    if (Number(points || 0) <= 0 && Number(burnPoints || 0) <= 0) {
      setTotalPayableAmount(finalAmount);
      setFinalPayableAmount(finalAmount);
    }
    if (isBuyNowAmountUpdating) {
      setIsBuyNowAmountUpdating(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData, convenienceFee, gst, points, burnPoints]);

  const currentBalance = usePoints();
  const handleTotalPayableAmountChange = (amount) => {
    setTotalPayableAmount(amount);
  };
  const productLoading = useSelector((state) => state.productReducer);
  const productList =
    productReducer?.modalProductData ?? productReducer?.arrayData?.arrayData;

  const orderData = OrderData();
  const earnPoint = EarnPoint();
  const sendMailData = SendMail();
  const getClientInfo = async () => {
    try {
      const { data = {} } = await axiosInstance.get(API.clientpaymentid, {
        params: {
          clientId: clientInfo?.clientData?.id,
          mode: clientInfo?.clientData?.mode,
        },
        headers: {
          ...axiosInstance.defaults.headers,
          Encryption: 2,
        },
      });
      const key = decryptAES(data?.response?.[0]?.resourceValue);
      setRazorPayKey(key);
    } catch {
      return null;
    }
  };
  const hasTracked = useRef(false);
  // const calculateEarnPoints = (item) => {
  //   return Math.round(
  //     (minEarn / getMinPrice(priceDenominations)) *
  //     (item - (item * discount) / 100)
  //   );
  // };
  useEffect(() => {
    const trackingContext = gaTrackingConfig?.trackingContext || {};
    const isTrackingContextReady =
      !!trackingContext.client_code &&
      !!trackingContext.platform_code &&
      !!trackingContext.affiliation;

    if (!hasTracked.current && quantities.length > 0 && isTrackingContextReady) {
      // Always use the correct sourceData
      const sourceData =
        productReducer?.arrayData?.arrayData ||
        productReducer?.modalProductData ||
        [];
      let basePayable = 0;
      let totalDiscount = 0;
      const discountPercent =
        productReducer?.productReducerDisocount?.customerDiscount || 0;

      // compute base payable and discount using quantities (preserve index mapping)
      quantities.forEach((qty, idx) => {
        const denomination = sourceData[idx]?.denomination || 0;
        const youPay = sourceData[idx]?.you_pay || 0;
        basePayable += (youPay || 0) * (qty || 0);
        totalDiscount += ((denomination * discountPercent) / 100) * (qty || 0);
      });

      // include convenience fee and gst to match add_to_cart final value
      const productMapping = productReducer?.productReducer || {};
      const convenienceFeePercent = Number(productMapping?.convenienceFee) || 0;
      const gstPercent = Number(productMapping?.gst) || 0;
      const convenienceFeeAmount = (basePayable * convenienceFeePercent) / 100;
      const gstAmount = (convenienceFeeAmount * gstPercent) / 100;
      const finalValue = basePayable + convenienceFeeAmount + gstAmount;

      const selectedCard = localStorage.getItem("RewardWidget");
      const cardData = getSelectedRewardCardData();
      const rewardPoints = calculateRewardPoints(finalValue, cardData);
      // build items array only for qty > 0 and include per-item total price (you_pay * qty)
      const items = sourceData
        .map((item, idx) => {
          const qty = quantities[idx] || 0;
          if (!qty || qty <= 0) return null;
          return {
            index: parseInt(sessionStorage.getItem("ga4_seletedProductIndex")) || null,
            item_brand: productReducer?.productReducer?.name,
            item_name: productReducer?.productReducer?.name,
            item_id: productReducer?.productReducer?.sku,
            affiliation: trackingContext.affiliation,
            item_category: "Giftcards",
            item_category2: productReducer?.productReducer?.clientCategoryName || "",
            item_image: getImageUrl(productReducer?.productReducer?.small) || defaultImage,
            gift_card_points: item?.denomination,
            quantity: qty,
            price: (item?.you_pay || 0) * qty,
            item_url: window.location.href.includes("/card?")
              ? window.location.href.replace("/card?", "/giftcard?")
              : window.location.href,
            //  item_url: prevUrl.current,
            item_list_name: sessionStorage.getItem("ga4_item_list_name") || "products",
            item_list_id: sessionStorage.getItem("ga4_item_list_name") || "products",
            discount: ((item?.denomination || 0) * discountPercent) / 100 * qty,
            DefaultCard: cardData?.cardName || "NA"
          };
        })
        .filter(Boolean);

      // Only track if there is at least one quantity > 0
      if (productDetails && finalValue > 0) {
        trackEvent("begin_checkout", {
          page_type: "checkout_page",
          client_code: gaTrackingConfig.trackingContext.client_code,
          platform_code: gaTrackingConfig.trackingContext.platform_code,
          page_url: window.location.href,
          DefaultCard: cardData?.cardName || "NA",
          total_gift_card_points: sourceData.reduce(
            (sum, item, idx) =>
              sum + (item.denomination || 0) * (quantities[idx] || 0),
            0
          ),
          card_name: selectedCard ? selectedCard : "NA",
          reward_points: rewardPoints,

          ecommerce: {
            currency: "INR",
            value: finalValue,
            discount: totalDiscount,
            items,
          }
        });
        hasTracked.current = true;
      }
    }
  }, [productReducer, quantities, cardListData, gaTrackingConfig]);
  const loadingData =
    productLoading?.isLoading ||
    loading ||
    orderData?.isLoading ||
    vendorData?.isPostLoading ||
    earnPoint?.isPostLoading ||
    generateToken?.isLoading ||
    sendSms?.isPostLoading ||
    redeemPoint?.isPostLoading ||
    sendMailData?.isPostLoading;
  const showCheckoutLoader =
    isLoading || orderData?.isLoading ||
    (!hostedReturnData?.isPaymentCancelled &&
      (loadingData || prodSumData?.isLoading));

  useEffect(() => {
    const finalAmount = roundCurrency(totalPayableAmount);
    setFinalPayableAmount(finalAmount);
    if (
      currentBalance === 0 ||
      (isCardJourney
        ? !effectiveBurn
        : isBurn === "2" ||
        productData?.maxEarnPoints === 0 ||
        !isBurnEnabledForSelectedCard)
    ) {
      setCash(finalAmount);
    }
  }, [
    totalPayableAmount,
    effectiveBurn,
    isBurnEnabledForSelectedCard,
  ]);

  useEffect(() => {
    const shouldClearBurn = isCardJourney
      ? !effectiveBurn
      : !isBurnEnabledForSelectedCard;
    if (shouldClearBurn && (points > 0 || burnPoints > 0)) {
      const finalAmount = roundCurrency(totalPayableAmount);
      setPoints(0);
      setBurnPoints(0);
      setCash(finalAmount);
    }
  }, [
    effectiveBurn,
    points,
    burnPoints,
    totalPayableAmount,
  ]);
  useEffect(() => {
    if (isCardJourney && !effectiveEarn && earnPoints !== 0) {
      setEarnPoints(0);
    }
  }, [effectiveEarn, earnPoints]);
  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem("login") === "true";
    const loginSessionToken = sessionStorage.getItem("loginSessionToken");

    if (
      isLoggedIn &&
      loginSessionToken &&
      loginV3Data?.memberIdentifier &&
      productReducer?.productReducer?.id
    ) {
      dispatch(
        onGetCustomerProduct({
          customerId: loginV3Data.memberIdentifier,
          productIdentifier: productReducer.productReducer.id,
        })
      );
    }
  }, [loginV3Data?.memberIdentifier, productReducer?.productReducer?.id]);
  const lastLimitCheckRef = useRef(null);
  useEffect(() => {
    let totaDenAmount = updatedData.reduce((acc, crr) => {
      return acc + crr.denomination * crr.quantity;
    }, 0);
    // The limit check only depends on these inputs; skip re-dispatching when
    // nothing changed (e.g. finalPayableAmount moving while the points slider drags).
    const limitInputs = [
      totaDenAmount,
      prodSumData?.getCustomerProduct,
      productReducer?.productReducer?.productBudget?.limits,
      !!sessionStorage.getItem("login"),
      translation?.next_day,
      translation?.next_week,
      translation?.next_month,
      translation?.next_quarter,
    ];
    const lastInputs = lastLimitCheckRef.current;
    if (
      lastInputs &&
      lastInputs.length === limitInputs.length &&
      lastInputs.every((value, index) => value === limitInputs[index])
    ) {
      return;
    }
    lastLimitCheckRef.current = limitInputs;
    handleLimit(
      totaDenAmount,
      prodSumData?.getCustomerProduct,
      dispatch,
      translation,
      productReducer?.productReducer?.productBudget?.limits
    );
  }, [finalPayableAmount]);

  useEffect(() => {
    const errorCode = orderData?.errorCode;
    const updatedOrderData = orderData?.updatedOrderData || {};
    const orderStatus = updatedOrderData?.orderStatus?.trim()?.toLowerCase();

    if (errorCode === "1461" || errorCode === "1462") {
      setLoading(false);
      dispatch(onPendingOrderReset());
      navigate("/processing-payment");
      return;
    }

    if (orderStatus === "completed") {
      setLoading(false);
      dispatch(onUpdateOrderReset());
      navigate("/order-confirmation", {
        state: updatedOrderData,
      });
      return;
    }

    if (orderStatus === "failed") {
      setLoading(false);
      dispatch(onUpdateOrderReset());
      navigate("/order-confirmation", {
        state: updatedOrderData,
      });
      return;
    }

    if (orderStatus === "pending") {
      setLoading(false);
      dispatch(onUpdateOrderReset());
      dispatch(onPendingOrderReset());
      navigate("/order-processing", {
        state: { orderDetails: true }
      });
    }
  }, [orderData?.errorCode, orderData?.updatedOrderData]);

  return (
    <>
      {showCheckoutLoader && <Loader />}
      {(!showCheckoutLoader || hostedReturnData?.isPaymentCancelled) && (
        <div className={`row${showCheckoutLoader ? " d-none" : ""}`} hidden={showCheckoutLoader}>
          <div className="col-lg-8 voucher-card-left-section">
            <div className="row mx-0  py-3 voucher-card-left-section-inner">
              <div className="col-lg-4 pe-0">
                <div className="d-flex w-100 h-100 justify-content-center">
                  <div>
                    <div className="w-100">
                      <img
                        className="w-144 card_main_image i-vch h-vch"
                        src={getImageUrl(productDetails?.mobile)}
                        alt={productDetails?.name || ""}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultImage;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-12 padding-50-1000-1400">
                <div
                  className={`row justify-content-between ${isProductAttributeGridEnabled ? "pb-0" : "pb-2"
                    } mt-1`}
                >
                  <div className="col-12 col-md-auto lh-1 cart-f pt-md-1">
                    {productDetails?.name}
                  </div>
                </div>
                <div className="row">
                  <div
                    className={
                      isProductAttributeGridEnabled ? "col-12" : "col-8"
                    }
                  >
                    {productReducer?.productReducerDisocount
                      ?.customerDiscount !== 0 &&
                      <span className={`${isDiscountShowLabelConfig ? "pro-discount" : "d-none"}`} >

                        {!journeyType && `${productReducer?.productReducerDisocount?.customerDiscount}% ${translation?.discountOffLabel}`}
                        {journeyType && `${translation?.flatDiscount} ${productReducer?.productReducerDisocount?.customerDiscount}% `}
                      </span>
                    }
                    {isProductAttributeGridEnabled ? (
                      // Checkout shows only the remaining limit, on one line.
                      <ProductAttributes include={["limit"]} layout="inline" />
                    ) : (
                      <span>
                        <ReedemType
                          status={
                            productReducer?.productReducer?.redeemableType || ""
                          }
                        />
                      </span>
                    )}
                  </div>
                  {!isProductAttributeGridEnabled && (
                    <div className="col-4">
                      <PurchaseLimitPill />
                    </div>
                  )}
                </div>
                <div
                  id="pricing-table-card"
                  className="pricing-table-card row"
                >
                  {/* Heading Row */}
                  <div className="heading-row col-lg-9">
                    <div className="heading">{translation?.value}</div>
                    <div className="heading1">{translation?.qty}</div>
                    <div className="heading">{translation?.youPay}</div>
                  </div>

                  {/* Data Rows */}
                  {(checkoutSourceData || []).map(
                      (value, index) => (
                        <div
                          className="pricing-row col-lg-9"
                          key={index}
                          style={outOfStockLabel[index] ? { opacity: 0.2 } : {}}
                        >
                          <div className="value">
                            ₹{value.denomination.toLocaleString()}
                          </div>
                          <div className="quantity">
                            {
                              <button
                                className={`quantity-btn-minus ${quantities[index] === 0
                                  ? "quantity-disabled"
                                  : ""
                                  }`}
                                onClick={() => updateQuantity(index, -1)}
                                disabled={quantities[index] === 0 || outOfStockLabel?.[index]}
                              >
                                -
                              </button>
                            }
                            <span className={`quantity-value `}>
                              {quantities[index]}
                            </span>
                            <button
                              className={`quantity-btn-plus  ${supplierCapping > 0 &&
                                quantities[index] === supplierCapping
                                ? "quantity-disabled"
                                : ""
                                }`}
                              onClick={() =>
                                updateQuantity(index, +1, value?.denomination)
                              }
                              disabled={
                                (supplierCapping > 0 &&
                                  quantities[index] === supplierCapping) ||
                                v3Data?.disable ||
                                outOfStockLabel?.[index]
                              }
                            >
                              +
                            </button>
                          </div>

                          <div className="price">
                            ₹
                            {formatPrice(
                              value.denomination * quantities[index] -
                              (value.denomination *
                                quantities[index] *
                                (productReducer?.productReducer
                                  ?.customerDiscount || 0)) /
                              100
                            )}
                          </div>
                        </div>
                      )
                    )}
                </div>
              </div>
            </div>
          </div>
          {isMobileView && outOfStockLabel?.some((label) => label === true) && (
            <div className="SelectedDominationUnavailable mt-4">
              <div className="d-flex justify-content-center align-items-center text-left">
                <div className="availble-left">
                  <img src={warning} alt="Unavailable" className="mr-2" />
                </div>
                <div className="availble-right">
                  <div className="unavailable-text">
                    {translation?.stockout_message_title}
                    {/* {translation?.selectedDenominationUnavailable} */}
                  </div>
                  <p>{filterStockOutDenominations?.map(item => `₹${formatPrice(item.denomination)}`).join(", ")}
                    {filterStockOutDenominations?.length > 1 ? ' are ' : ' is '}
                    {translation.stockout_message_desc}
                  </p>
                </div>
              </div>
            </div>
          )
          }
          <div className="col-lg-4 position-relative voucher-card-right-section">
            {/* <div className="col-lg-4"> */}
            <div className="mt-desk-3">
              <RewardWidget totalAmount={totalAmount} stockOutDenominations={stockOutDenominations} />
            </div>

            <RightCart
              productReducer={productReducer}
              updatedData={updatedData}
            />
            {isCardJourney && (
              <RewardRedemption
                cards={cards}
                allCards={cardBasedRedemtionList}
                selectedCard={selectedCardBasedRedemtion}
                selectedCardId={selectedCardId}
                setSelectedCardId={setSelectedCardId}
                setSelectedCard={setselectedCardBasedRedemtion}
                cardBalances={cardBalances}
                setCardBalances={setCardBalances}
                matchedCardMasterData={MatchedCardMasterData}
                isEarnEnabled={isEarnEnabledForSelectedCard}
                isBurnEnabled={isBurnEnabledForSelectedCard}
                isClientEarnEnabled={isClientEarnEnabled}
                isClientBurnEnabled={isClientBurnEnabled}
                productSupportsEarn={productSupportsEarn}
                productSupportsBurn={productSupportsBurn}
                effectiveEarn={effectiveEarn}
                effectiveBurn={effectiveBurn}
                clientConfigurations={clientConfigurations}
                productReducer={productReducer}
                productData={productData}
                updatedData={updatedData}
                convenienceFee={convenienceFee}
                gst={gst}
                points={points}
                setPoints={setPoints}
                setBurnPoints={setBurnPoints}
                setCash={setCash}
                onTotalPayableAmountChange={handleTotalPayableAmountChange}
                setEarnPoints={setEarnPoints}
              />
            )}

            {v3Data?.disable && (
              <>
                <PurchaseLimitAlertTile
                  timePeriod={v3Data?.timePeriod}
                  amount={v3Data?.amount}
                  name={productReducer?.productReducer?.name}
                  reset_text={v3Data?.reset_text}
                />

                <div className="overlay-block position-absolute w-100 h-100 top-0 start-0"></div>
              </>
            )}
            {!isMobileView && outOfStockLabel?.some((label) => label === true) && (
              <div className="SelectedDominationUnavailable mt-4">
                <div className="d-flex justify-content-center align-items-center text-left">
                  <div className="availble-left">
                    <img src={warning} alt="Unavailable" className="mr-2" />
                  </div>
                  <div className="availble-right">
                    <div className="unavailable-text">
                      {translation?.stockout_message_title}
                      {/* {translation?.selectedDenominationUnavailable} */}
                    </div>

                    <p>{filterStockOutDenominations?.map(item => `₹${formatPrice(item.denomination)}`).join(", ")}
                      {filterStockOutDenominations?.length > 1 ? ' are ' : ' is '} {translation.stockout_message_desc}</p>
                  </div>
                </div>
              </div>
            )
            }

            {!isCardJourney && isEarnEnabledForSelectedCard && (
              <SelectCard
                points={points}
                productReducer={productReducer}
                updatedData={updatedData}
                setEarnPoints={setEarnPoints}
                convenienceFee={convenienceFee}
                gst={gst}
              />
            )}

            {!isCardJourney && isBurn !== "2" &&
              productData?.maxEarnPoints > 0 &&
              currentBalance > 0 &&
              isBurnEnabledForSelectedCard &&

              <ThePoints
                key={selectedCardId || "default-redemption-card"}
                cash={cash}
                setCash={setCash}
                points={points}
                setPoints={setPoints}
                productDataw={productReducer}
                productReducer={productReducer?.productReducerDisocount}
                updatedData={updatedData}
                productData={productData}
                onTotalPayableAmountChange={handleTotalPayableAmountChange}
                setBurnPoints={setBurnPoints}
                minDenomination={minDenomination}
                stockOutDenominations={stockOutDenominations}
                selectedCardBasedRedemtion={selectedCardBasedRedemtion}
              />
            }

            <Refundable />
            {/* <UserDetails
              points={points}
              cash={cash}
              setLoading={setLoading}
              totalPayableAmount={finalPayableAmount}
              quantities={quantities}
              productReducer={productReducer}
              updatedData={updatedData}
              productData={productData}
              burnPoints={burnPoints}
              earnPoints={earnPoints}
              razorPayKey={razorPayKey}
              setTotalPayableAmount={setTotalPayableAmount}
              setPoints={setPoints}
              setBurnPoints={setBurnPoints}
              convenienceFee={convenienceFee}
              gst={gst}
              currentBalance={currentBalance}
              disabled={v3Data?.disable}
              setOrderJourneyStarted={setOrderJourneyStarted}
            /> */}
            <CheckoutProvider value={{
              points,
              cash,
              setCash,
              setLoading,
              totalPayableAmount: finalPayableAmount,
              quantities,
              stockOutDenominations,
              productReducer,
              updatedData,
              productData,
              burnPoints,
              earnPoints,
              setTotalPayableAmount,
              setPoints,
              setBurnPoints,
              convenienceFee,
              gst,
              currentBalance,
              disabled: v3Data?.disable || prodSumData?.isLoading,
              setOrderJourneyStarted,
              selectedCardBasedRedemtion,
              cardBasedRedemtionList,
              cardBalances,
              setCardBalances,
              isBuyNowAmountUpdating,
              isHostedPayUCancelReturn: hostedReturnData?.isPaymentCancelled,
              effectiveEarn: isCardJourney ? effectiveEarn : true,
              effectiveBurn: isCardJourney ? effectiveBurn : true,
            }}>
              <CheckoutPage />
            </CheckoutProvider>
          </div>
        </div>
      )}

      {orderJourneyStarted && <Loader />}
    </>
  );
};
export default Voucher;
